import { BLACK, TURQOISE } from 'constants/colours';

export default {
  iconLink: {
    display: 'block',
    position: 'relative',
  },

  hoverFix: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },

  iconLinkColour: BLACK,
  iconLinkColourHover: TURQOISE,
};



// WEBPACK FOOTER //
// ./src/components/IconLink/IconLink.style.js